<template>
  <div>
    <UPageCTA
      orientation="horizontal"
      variant="naked"
      title="Free forever"
      reverse
      description="We'll give away the most features for free, so you can use it for small business and hobby projects without worry. We're backing up your data daily on a second location. We are GDPR compliant. And yes, you can get in contact with us on email."
      :ui="{
        container: 'lg:grid-cols-2 gap-y-12 lg:items-center',
        title: 'max-lg:text-center',
        description: 'max-lg:text-center',
        links: 'max-lg:justify-center',
      }"
    >
      <UPageCard
        v-if="!loggedIn"
        variant="solid"
        class="mx-auto bg-gray-200 shadow-xl text-black border-slate-200 dark:bg-gray-900 dark:text-white dark:border-gray-800 border max-w-sm w-full p-4"
      >
        <LoginForm
          force-create
          @create-user-success="onCreateUserSuccess"
          @login-success="onLoginSuccess"
        />
      </UPageCard>
    </UPageCTA>
  </div>
</template>

<script setup lang="ts">
const { loggedIn, user, fetch: refreshSession } = useUserSession();
const verifiedAt = user.email_verified_at;
const route = useRoute();
const redirectTo = computed(() =>
  typeof route.query.redirectTo === "string" &&
  route.query.redirectTo.startsWith("/")
    ? route.query.redirectTo
    : "/",
);
if (loggedIn.value && verifiedAt) {
  await navigateTo(redirectTo.value);
} else if (loggedIn.value && !verifiedAt) {
  await navigateTo("/account-needs-verification");
}

async function onLoginSuccess() {
  console.log("on login success!");
  await refreshSession();
  await navigateTo(redirectTo.value);
}

async function onCreateUserSuccess() {
  console.log("on create user success!");
  // do nothing
}
</script>
